import styled from '@emotion/styled';
export const PageContainer = styled.div`
  label: JMT-General-PageContainer;
  display: flex;
  flex-direction: column;
  padding: 2rem 100px 60px 100px;
  flex: 1;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 992px) {
    padding: 20px 25px;
    margin-top: 85px;
  }
`;